module.exports = __webpack_public_path__ + "img/add-file.70d5674a.svg";